import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const DEFAULTS = { app_name: "PlantPulse", tagline: "Performance Control", company_name: "", logo_url: null, needs_setup: false };
const Ctx = createContext({ settings: DEFAULTS, refetch: () => {} });

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  const q = useQuery({ queryKey: ["settings", user?.id || "anon"], queryFn: async () => (await api.get("/settings")).data, staleTime: 60_000 });
  return <Ctx.Provider value={{ settings: q.data || DEFAULTS, refetch: q.refetch }}>{children}</Ctx.Provider>;
}

export const useSettings = () => useContext(Ctx);
